module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._core-js@2.5.0@core-js/modules/_library.js
// module id = ../../../../._core-js@2.5.0@core-js/modules/_library.js
// module chunks = 2